import useIdleEffect from "../../bit/board/hooks/useIdleEffect";

const useIdleEffectWithDisable = (
  onIdle: () => void = () => null,
  timeout = 90000,
  disabled = false,
) => {
  useIdleEffect(() => {
    if (!disabled) {
      onIdle();
    }
  }, timeout);
};

export default useIdleEffectWithDisable;
